<template>
  <div>
    <Modal v-model="mdl" width="740" class-name="vertical-center-modal no-padding">
      <div class="close-btn" slot="close">
        <i class="iconfont icon-pop-close"></i>
      </div>
      <div class="m-header">
        <div
          class="m-search-box"
          v-show="!noFavResource"
          @mouseenter="openInput"
          @mouseleave="closeInput"
        >
          <i class="iconfont icon-search" style="font-size:20px;"></i>
          <input type="text" v-model="filter.keyword" @keyup="keyup($event)" placeholder="请输入关键字搜索">
        </div>
        <div class="title">从收藏夹添加</div>
      </div>
      <div class="classButton" v-if="type !== 1">
        <span @click="changetype(1)" :class="type === 1 ? 'active' : ''" v-if="!showType">单品</span>
        <!-- <span @click="changetype(2)" :class="type === 2 ? 'active' : ''">场景</span> -->
        <!-- <span @click="changetype(3)" :class="type === 3 ? 'active' : ''">灵感源</span> -->
      </div>
      <div class="m_cont my-scroll-styles">
        <div class="list" v-show="products.length" @scroll="listScroll">
          <div
            v-if="showType"
            class="product-img dddddd"
            :key="index"
            v-for="(product,index) in products"
            @click="addDetailedList(product, product.id, true)"
            :class="{'selected':selProducts === product.id}"
          >
            <img :src="imgBaseUrl+product.coverFile.key" v-if="product.coverFile">
            <img
              :src="imgBaseUrl+product.inspirationFile.key"
              v-if="product.inspirationFile && !product.coverFile"
            >
          </div>
          <div style="clear:both;  display: inline-block;">
            <div
              v-if="!showType"
              class="product-img"
              :key="index"
              @click="addDetailedList(product, product.id)"
              v-for="(product,index) in products"
              :class="{'selected':selProducts.includes(product.id)}"
            >
              <img :src="imgBaseUrl+product.coverFile.key" v-if="product.coverFile">
              <span class="disabled-instriled" v-if="product.disabled === 1">产品失效</span>
              <span class="disabled-instriled" v-if="product.status === 0">临时单品</span>
            </div>
          </div>
          <div style="clear:both; display: block;"></div>
          <div
            class="page"
            style="text-align: center;margin-top: 20px"
            v-show="products.length > 0"
          >
            <Page
              :page-size="filter.pageSize"
              @on-change="changePage"
              :current="filter.pageNum"
              :total="total"
            ></Page>
          </div>
        </div>
        <div v-if="!busy&&!products.length" class="no-result">
          <div v-if="historyKeyword">
            <img src="../../../images/cut/search_no_result.png">
            <p>没有找到 "{{historyKeyword}}" 相关的内容,试试输入其他关键词</p>
          </div>
          <div v-else>
            <img src="../../../images/cut/fav_null.png">
            <p>收藏夹是空的，快去收藏感兴趣的产品</p>
          </div>
        </div>
      </div>
      <div class="footer">
        <button
          v-if="!this.showType"
          class="red-btn"
          style="width:145px;"
          @click="addCollectProducts"
        >确 认</button>
        <button v-else class="red-btn" style="width:145px;" @click="addCollectProductsImgSearch">确 认</button>
      </div>
    </Modal>
  </div>
</template>

<style lang="scss" scoped>
.m-header {
  padding: 22px 0;
  height: 84px;
  line-height: 40px;
}
.m-header .m-search-box {
  width: auto;
  min-width: 40px;
  height: 40px;
  line-height: 40px;
  position: absolute;
  top: 22px;
  left: 30px;
  text-align: left;
}
.m-header .m-search-box input {
  background: #f2f4f5;
  border-radius: 100px;
  padding-left: 40px;
  height: 40px;
  line-height: 40px;
  width: 0px;
  transition: all 0.5s ease-in-out;
}
.m-header input.open {
  width: 220px;
}
.m-header .m-search-box i.icon-search {
  position: absolute;
  left: 10px;
  top: 0px;
  color: #6c6f70;
}
.m-header .title {
  font-size: 20px;
  color: #353838;
  letter-spacing: 3.33px;
  display: inline-block;
  margin-left: 32px;
}
.classButton {
  margin-bottom: 20px;
}
.classButton span {
  display: inline-block;
  font-size: 14px;
  color: #353838;
  width: 50px;
  text-align: center;
  cursor: pointer;
  height: 30px;
  line-height: 30px;
  margin-left: 30px;
}
.classButton span.active {
  color: #308697;
  border-bottom: 2px solid #308697;
}
.classButton span:first-child {
  margin-left: 17px;
}
.classButton span:hover {
  color: #308697;
  border-bottom: 2px solid #308697;
}
.no-result {
  text-align: center;
  padding-top: 0;
}
.no-result img {
  width: 110px;
  margin-top: 40px;
}
.no-result p {
  font-size: 14px;
  color: #a2a2a8;
  margin-top: 40px;
}
.list {
  padding-left: 20px;
  margin: 2px 0;
  text-align: left;
}
.m_cont {
  height: 410px;
  overflow-y: scroll;
}
.list .product-img {
  background: #f2f4f5;
  border-radius: 4px;
  text-align: center;
  width: 120px;
  height: 120px;
  line-height: 120px;
  float: left;
  margin: 10px;
  position: relative;
}
.list .product-img .disabled-instriled {
  display: inline-block;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  text-align: center;
  line-height: 120px;
  color: #fff;
  font-size: 14px;
  position: absolute;
  left: 0;
  top: 0;
}
.list .product-img.selected:before {
  width: 120px;
  height: 120px;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  background-image: url("../../../images/cut/selected_pro.png");
}
.list .product-img img {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
}
.footer {
  padding: 30px 0;
}
</style>

<style lang="scss">
.page {
  .ivu-page {
    display: inline-block;
  }
}
</style>

<script>
import api from "../../../api";
export default {
  data() {
    return {
      mdl: false,
      imgBaseUrl: api.common.imgBaseUrl,
      products: [],
      productsList: [],
      filter: {
        keyword: "",
        pageNum: 1,
        pageSize: 20
      },
      busy: false,
      total: 0,
      historyKeyword: "",
      noFavResource: false,
      selProducts: [],
      detailedListId: undefined,
      showType: null,
      type: 1,
      imgKey: null,
      imgId: null
    };
  },
  methods: {
    changePage(current) {
      this.filter.pageNum = current;
      this.getCollectedProducts();
    },
    openInput(e) {
      let input = e.target.querySelector("input");
      input.focus();
      input.className = "open";
    },
    closeInput(e) {
      if (!this.filter.keyword.trim()) {
        e.target.querySelector("input").className = "";
        if (this.filter.keyword) {
          this.initFilter();
          this.updateCollectProducts();
        }
      }
    },
    keyup(e) {
      if (e.key == "Enter" || e.keyCode == 13) {
        if (this.filter.keyword.length && !this.filter.keyword.trim()) {
          return;
        }
        this.initFilter();
        this.updateCollectProducts();
      }
    },
    listScroll(e) {
      let s_top = e.target.scrollTop;
      let height = e.target.scrollHeight;
      if (height - s_top < 2 * 410) {
        if (this.filter.pageNum * this.filter.pageSize < this.total) {
          this.filter.pageNum++;
          this.updateCollectProducts();
        }
      }
    },
    initFilter() {
      this.products = [];
      this.filter.pageNum = 1;
      this.filter.pageSize = 20;
    },
    open(detailedListId, type) {
      this.mdl = true;
      this.detailedListId = detailedListId || 0;
      this.selProducts = [];
      this.filter.keyword = "";
      this.initFilter();
      type ? (this.showType = type) : (this.showType = null);
      type ? (this.type = 3) : (this.type = 1);
      this.getCollectedProducts();
    },
    updateCollectProducts() {
      this.filter.keyword = this.filter.keyword.trim();
      this.historyKeyword = this.filter.keyword;
      this.getCollectedProducts();
    },
    changetype(type) {
      this.type = type;
      this.getCollectedProducts();
    },
    getCollectedProducts() {
      this.busy = true;
      this.products = [];
      api.imgSearch.resources(this.type, this.filter).then(
        res => {
          this.products = this.products.concat(res.list);
          this.productsList = this.productsList.concat(res.list);
          this.total = res.total;
          if (
            !this.filter.keyword &&
            (!this.products || !this.products.length)
          ) {
            this.noFavResource = true;
          }
          this.busy = false;
        },
        () => {
          this.busy = false;
        }
      );
    },
    addDetailedList(product, id, target = false) {
      // if ((product.disabled === 1 || product.status === 0) && target) {
      //   return;
      // }
      if (!this.showType) {
        if (product.disabled === 1 || product.status === 0) {
          return;
        }
        if (this.selProducts.includes(id)) {
          this.selProducts.splice(
            this.selProducts.findIndex(pid => pid === id),
            1
          );
        } else {
          this.selProducts.push(id);
        }
      } else {
        let newData = new Array();
        this.selProducts = newData[0] = id;
        this.imgKey =
          this.type === 2 ? product.coverFile.key : product.inspirationFile.key;
        this.imgId =
          this.type === 2 ? product.coverFile.id : product.inspirationFile.id;
      }
    },
    addCollectProducts(specId, productId) {
      if (this.mdl) {
        this.mdl = false;
        let items = [];
        let itProductSpecId = "";
        this.productsList.forEach(product => {
          if (this.selProducts.includes(product.id)) {
            if (product.specs[0].visible === 1) {
              itProductSpecId = product.specs[0].id;
            } else {
              itProductSpecId = product.specs.filter(re => re.visible === 1)[0]
                .id;
            }
            items.push({
              productSpecId: itProductSpecId,
              productId: product.id,
              type: 1
            });
          }
        });
        // empty products list
        this.productsList = [];
        if (items.length) {
          api.detailedLists.addProduct(this.detailedListId, items).then(res => {
            this.$Message.success("添加成功");
            this.$emit("addSuccess", res[0].detailedListId);
          });
        } else {
          this.mdl = false;
        }
      }
    },
    //添加到图片识别搜索
    addCollectProductsImgSearch() {
      if (this.imgKey && this.imgKey) {
        this.$emit("selfavImgHandle", this.imgKey, this.imgId);
        this.mdl = false;
      }
    }
  },
  watch: {
    mdl: function() {
      if (!this.mdl) {
        this.filter.pageNum = 1;
      }
    }
  }
};
</script>